import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./ScrapReasonFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import { validate } from "../../../custom/validations/Validate";
import { getRecords, saveRecords } from "../../../services/api.service";
import { toast } from "react-toastify";

const ScrapReasonCreate = () => {
  const schema = localStorage.getItem("schema")
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        schema: schema,
        whereCondition: { id: id, is_active: true },        
      }

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({inputData:data})
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };


  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)
      if (JSON.stringify(validationErrors) !== "{}") return
      
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id:id, inputData: formData?.inputData, relation: [] }

      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData?.inputData, relation: [] }

      }

     console.log(payload)
    //   return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  

  

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        
        <Col md="6" className="mt-3">
          <TextInput
            label="Reason"
            name="reason"
            value={formData?.inputData?.reason}
            onChange={onInputChange}
            placeholder="Reason"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.reason}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Description"
            name="descriptions"
            value={formData?.inputData?.descriptions}
            onChange={onInputChange}
            placeholder="Description"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.descriptions}
          />
        </Col>
        
        
        
        
      </Row>

      {/* Add documents */}

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default ScrapReasonCreate;
